<template>
        <div style = "position: relative;" class="register">
            <div v-if="!showVerifyWithGoogle" class="position_back_button backButtonOne">
                <button class="btn-back btn w-45px mt-15 mb-15" @click="clearEmailField">
                    <v-icon class="material-icons-round"> arrow_back </v-icon>
                </button>
            </div>
            <div class="register--container">
                <p v-if="showVerifyWithGoogle" class="register--title mb-0">Email</p>
                <p v-if="showVerifyWithGoogle" class="register--subtitle">Please enter your email address.</p>
                <div class="register__form mt-40">
                    <ValidationProvider name="Email" rules="email|required" v-slot="{ invalid, errors, classes }">
                        <div v-if="showVerifyWithGoogle" class="input-group mb-5" :class="classes">
                            <div class="input-group-prepend">
                                <span class="input-group-text">
                                    <v-icon style = "color: #9e9e9e" class="material-icons-round">mail</v-icon>
                                </span>
                            </div>
                            <input type="email" id="email" class="form-control" :disabled="!showVerifyWithGoogle" v-model="emailId" placeholder="abc@example.com">
                        </div>
                        <small class="form-group--error-message">{{ errors[0] }}</small>
                        <div style="display: flex; justify-content: center; align-items: center" class="register__form--referral-bottom" v-if="showVerifyWithGoogle">
                            <button class="email-step1 btn_new btn-secondary-new w-80 mt-15 mb-15"
                                @click="sendEmailVerification"
                                v-if="!showOtpField"
                                :disabled="invalid"
                            >
                                Next
                            </button>
                        </div>
                    </ValidationProvider>
                    <div class="bottom" v-if="!showVerifyWithGoogle">
                        <ValidationProvider name="OTP" rules="digits:6|required" v-slot="{ invalid, errors, classes }">
                            <p class="register--title mb-0">Verify</p>
                            <p class="register--subtitle">We have sent a 6 digit code to your email <strong>{{emailId}}</strong></p>
                            <div class="otp-input-wrap mb-5">
                                <div class="otpWidth otp-input-wrap mb-5" :class="classes">
                                    <v-otp-input
                                    v-model = "otp"
                                    type="number"
                                    @finish="confirmOtp">
                                    </v-otp-input>
                                </div>
                            </div>
                            <small class="form-group--error-message">{{ errors[0] }}</small>

                            <div class="otp">
                                <p class="otp--resend rightAlign" v-if="!otpTime">
                                     Did not receive OTP? <a @click="receiveOtp" class="ml-5"> Resend </a>
                                </p>

                                <p class="otp--timer rightAlign" v-else>
                                    You can resend the OTP in {{otpTime}} sec
                                </p>
                            </div>
                            <div style="display: flex; justify-content: center; align-items: center" class="register__form--referral-bottom">
                                <button class="email-step2 btn_new btn-secondary-new w-80 mt-15 mb-15"
                                    @click="verifyEmailVerificationOtp"
                                    :disabled="invalid"
                                >
                                    Next
                                </button>
                            </div>
                        </ValidationProvider>
                    </div>
                </div>
                <div v-if="showVerifyWithGoogle">
                    <div class="register--or">
                        <span>or</span>
                    </div>
                    <div style="display: flex; justify-content: center; align-items: center" id="gSignInWrapper">
                        <button style="width: 310px; border-radius: 8px; height: 38px" id="google-button" class="email-google google-signUp"><i class="sprite icon-google mr-10"></i> Continue with Google</button>
                    </div>
                    <div id="name"></div>
                </div>
            </div>
            <v-snackbar
                v-model="otpFailureSnackbar"
            >
                    Incorrect OTP

                <template v-slot:action="{ attrs }">
                    <v-btn
                        color="red"
                        text
                        v-bind="attrs"
                        @click="otpFailureSnackbar = false"
                    >
                    Close
                    </v-btn>
                </template>
            </v-snackbar>
        </div>
</template>
<script>
/* eslint-disable */
import onboardingService from '@/services/lenderOnboardingService'

export default {
    name: 'EmailVerification',
    data () {
        return {
            emailId: null,
            showOtpField: false,
            otpField: null,
            emailType: 'default',
            showInvalidInputError: false,
            showInternalError: false,
            showVerifyWithGoogle: true,
            otp: '',
            otpTime: 0,
            otpFailureSnackbar: false
        }
    },
    watch: {
        otpTime: {
            handler (value) {
                if (value > 0) {
                    setTimeout(() => {
                        this.otpTime--
                    }, 1000)
                } else {
                    this.otpTime = 0
                }
            },
            immediate: true // This ensures the watcher is triggered upon creation
        },
        otp: {
            handler (value) {
                if (value.length === 6) {
                    this.verifyEmailVerificationOtp(value)
                }
            },
            deep: true,
            immediate: true
        }
    },
    mounted () {
        window.gapi.load('auth2', () => {
        const auth2 = window.gapi.auth2.init({
            client_id: process.env.VUE_APP_GOOGLE_CLIENT_ID,
            cookiepolicy: 'single_host_origin'
        })
        auth2.attachClickHandler(document.getElementById('google-button'), {}, googleUser => {
                this.onSignIn(googleUser)
            }, 
            error => console.log(error))
        })
    },
    methods: {
        confirmOtp (otp) {
            this.otp = otp
        },
        receiveOtp () {
            this.otp = ''
            this.sendEmailVerification()
        },
        clearEmailField () {
            this.otp = null
            this.otpTime = 0
            this.showVerifyWithGoogle = true
        },
        onSignIn (user) {
            const profile = user.getBasicProfile()
            const idToken = user.getAuthResponse().id_token
            this.emailId = profile.ev
            this.emailType = 'google'
            this.sendEmailVerification(idToken)
        },
        async sendEmailVerification (token) {
            this.$store.commit('isLoading')
            const payload = {
                emailId: this.emailId,
                emailType: this.emailType
            }
            if (token) {
                payload.gToken = token
            }
            await onboardingService.emailVerification(payload).then((res) => {
                if (res.status === 200) {
                    if (this.emailType === 'google') {
                        this.endEmailVerification()
                    }
                    this.otpTime = 120
                    this.showVerifyWithGoogle = false
                } else if (res.status === 400) {
                    this.showInvalidInputError = true
                } else if (res.status === 403) {
                    this.$router.push('/login')
                }else if (res.status === 500) {
                    this.showInternalError = true
                }
                this.$store.commit('isNotLoading')
            })
        },
        verifyEmailVerificationOtp (otp) {
            this.$store.commit('isLoading')
            const payload = {
                otp: otp
            }
            onboardingService.verifyEmailUsingOtp(payload).then((res) => {
                if (res.status === 200) {
                    this.endEmailVerification()
                } else if (res.status === 400) {
                    this.otp = ''
                    this.otpFailureSnackbar = true
                }
                this.$store.commit('isNotLoading')
            })
        },
        endEmailVerification () {
            this.$store.dispatch('onBoarding/setField', { field: 'Email', value: this.emailId })
            this.$emit('success')
        }
    }
}
</script>

<style lang="scss" scoped>
@import "~@/sass/components/registration-flow.scss";

.email-step1 {
}
.email-step2 {
}
.email-google {
}
#gSignInWrapper {
    margin-top: 60px;
}

.register__form--referral-bottom {
    margin-top: 10px;
}

.rightAlign {
    text-align: right;
}
::placeholder {
    color: #e0e0e0
}

::v-deep .v-text-field--outlined > .v-input__control > .v-input__slot {
        min-height: 45px;
        max-width: 45px;
}
.otpWidth {
        width: 385px
}

@media (max-width: 990px) {
    .otpWidth {
        width: 340px
        }
}

.bottom { 
    position: relative;
    top: 40px
}
.position_back_button {
    z-index: 1;
    position: absolute;
    top: 0px
}
</style>
